export type DocScope = 'sales' | 'purchase' | 'stock';
export type SalesDocType = 'quote' | 'order' | 'delivery' | 'invoice' | 'credit_note';
export type PurchaseDocType = 'order' | 'reception' | 'invoice' | 'credit_note';
export type StockDocType = 'stock_exit' | 'stock_entry';
export type AnyDocType = SalesDocType | PurchaseDocType | StockDocType;

const SALES_TITLES: Record<SalesDocType, string> = {
  quote: 'DEVIS',
  order: 'COMMANDE',
  delivery: 'BON DE LIVRAISON',
  invoice: 'FACTURE',
  credit_note: 'AVOIR',
};

const PURCHASE_TITLES: Record<PurchaseDocType, string> = {
  order: 'COMMANDE FOURNISSEUR',
  reception: 'BON DE RÉCEPTION',
  invoice: "FACTURE D\u2019ACHAT",
  credit_note: 'AVOIR FOURNISSEUR',
};

const STOCK_TITLES: Record<StockDocType, string> = {
  stock_exit: 'BON SORTIE',
  stock_entry: 'BON ENTREE',
};

export function getDocTitle(scope: DocScope, docType: AnyDocType): string {
  if (scope === 'sales') return SALES_TITLES[docType as SalesDocType] ?? String(docType).toUpperCase();
  if (scope === 'stock') return STOCK_TITLES[docType as StockDocType] ?? String(docType).toUpperCase();
  return PURCHASE_TITLES[docType as PurchaseDocType] ?? String(docType).toUpperCase();
}
